export { SkyTextExpandRepeaterComponent } from './text-expand-repeater.component';
export { SkyTextExpandRepeaterModule } from './text-expand-repeater.module';
